import React from "react";
import {SendProductBulk} from "../components/SendProductBulk";

export const SendProductBulkPage = () => {
    return (
        <div>
            <SendProductBulk />
        </div>
    )
}